/**
 * browse_button option is supposed to be provided
 */
import _ from 'lodash'
import plupload from 'plupload'
import dataProvider from 'service/data_provider'
import Router from 'service/router'

const MEDIA_SESSION_KEY = dataProvider.get('mediaSessionKey')

const DEFAULT_CONFIG = {
    runtimes: 'html5',
    multi_selection: true,
    url: Router.path('media_upload_post_photo'),
    multipart_params: {},
    max_retries: 2,
    filters: {
        max_file_size: '15mb',

        // PLUpload's client-side image resizing is limited to 15000x15000px images:
        // http://www.plupload.com/docs/Image-Resizing-on-Client-Side#limitations
        max_img_dimensions: 15000,
        mime_types: [{ title: 'Image files', extensions: 'jpg,jpeg,png' }],
        prevent_duplicates: true,
    },
}

const getConfig = (config = {}) => ({
    ...DEFAULT_CONFIG,
    ...config,
    'media-session-key': getMediaSessionKey(),
    multipart_params: { _token: dataProvider.get('csrfToken') },
})

/**
 * Create plupload instance
 *
 * @param  {Object} config  Plupload config extending
 * @return {plupload.Uploader} Uploader instance
 */
const create = (config) => {
    const uploader = new plupload.Uploader(getConfig(config))

    // allow to use listenTo on instance
    uploader.on = uploader.bind

    // Notice: Backbone-ish syntax for removing all handlers of exact type is not supported (`.off('event')`)
    uploader.off = (type, fn) => {
        if (typeof type === 'undefined') {
            uploader.unbindAll()
            return
        }

        uploader.unbind(type, fn)
    }

    // prevent double init
    uploader.init = _.once(uploader.init)

    return uploader
}

// add max image dimensions filter
plupload.addFileFilter('max_img_dimensions', function(maxImageDimensions, file, callback) {
    const image = new plupload.moxie.image.Image()

    const finalize = (result) => {
        // cleanup
        image.destroy()

        // if rule has been violated in one way or another, trigger an error
        if (!result) {
            this.trigger('Error', {
                code: plupload.IMAGE_DIMENSIONS_ERROR,
                file,
            })
        }

        callback(result)
    }

    image.onload = () => {
        // check if resolution cap is not exceeded
        finalize(image.width <= maxImageDimensions && image.height <= maxImageDimensions)
    }

    image.onerror = () => {
        finalize(false)
    }

    image.load(file.getSource())
})

const getMediaSessionKey = () => MEDIA_SESSION_KEY

export default {
    create,
    getMediaSessionKey,
}
